import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import sessionStore from "@/stores/session";

import jsonEN from "./locales/en/translation.json"
import jsonES from "./locales/es/translation.json"
import jsonIT from "./locales/it/translation.json"

let HAS_I18N_BEEN_SETUP = false

const FALLBACK_LANGUAGE = "en"

export const setupI18n = () => {
  if (HAS_I18N_BEEN_SETUP) return

  // Do not EVER call the init multiple times
  // https://www.i18next.com/overview/api#init
  HAS_I18N_BEEN_SETUP = true;

  i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: jsonEN
      },
      es: {
        translation: jsonES
      },
      it: {
        translation: jsonIT
      },
    },
    lng: sessionStore.language,
    fallbackLng: FALLBACK_LANGUAGE,
    debug: false,
    ns: ["translation"],
    react: {
      transKeepBasicHtmlNodesFor: ['b', 'br', 'code', 'em', 'ul']
    }
  })
}